export default "__VITE_ASSET__CIU7UkpH__"